// Option B : le tableau de bord B2B s'appuie sur la session portail (cookie httpOnly).
// Aucune clé API n'est conservée côté navigateur ; l'ancienne clé de sessionStorage est
// supprimée au chargement.
import React, { createContext, useContext, useEffect, useCallback } from 'react';
import { portalApi } from '../services/portalApi';
import { purgerAncienneCle } from '../services/b2bApi';

const B2BContext = createContext();

export const B2BProvider = ({ children }) => {
  useEffect(() => {
    purgerAncienneCle();
  }, []);

  const logout = useCallback(async () => {
    await portalApi('/api/portal/logout', { method: 'POST' });
  }, []);

  return (
    <B2BContext.Provider value={{ logout }}>
      {children}
    </B2BContext.Provider>
  );
};

export const useB2BAuth = () => useContext(B2BContext);
